import { render, staticRenderFns } from "./ClientResult.vue?vue&type=template&id=66492cd9&"
import script from "./ClientResult.vue?vue&type=script&lang=js&"
export * from "./ClientResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports